export default "__VITE_ASSET__659e1945__"